import { createContext, useContext } from 'react';

/* eslint-disable @typescript-eslint/no-unused-vars */
const atlantisContextDefaultValues = {
    dateFormat: "P",
    // The system time is "p"
    timeFormat: "p",
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    floatSeparators: { group: ",", decimal: "." },
    currencySymbol: "$",
    locale: "en",
};
const AtlantisContext = createContext(atlantisContextDefaultValues);
function useAtlantisContext() {
    return useContext(AtlantisContext);
}

export { AtlantisContext as A, atlantisContextDefaultValues as a, useAtlantisContext as u };
